export const env: { [s: string]: (string | null); } = {
  'npm_package_version': '2024.1.18-LCA-SNAPSHOT.0'
};
